import Vue from 'vue'
import VueRouter from 'vue-router'
//路由跳转当前页报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Index',
    meta:{title:'税法随便问'},
    component: () => import(/* webpackChunkName: "about" */ '../components/HeaderNav.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "about" */ '../views/index/index.vue'),
        meta:{title:'税法随便问',
          keepAlive: true}
      },
      {
        path: '/question',
        name: 'Question',
        component: () => import(/* webpackChunkName: "about" */ '../views/question/question.vue'),
        meta:{title:'税法随便问'}
      },
      {
        path: '/center',
        name: 'Center',
        component: () => import(/* webpackChunkName: "about" */ '../views/center/center.vue'),
        meta:{title:'税法随便问'}
      },
      {
        path: '/record',
        name: 'Record',
        component: () => import(/* webpackChunkName: "about" */ '../views/record/record.vue'),
        meta: {title: '税法随便问'}
      },
      {
        path: '/collection',
        name: 'Collection',
        component: () => import(/* webpackChunkName: "about" */ '../views/collection/collection.vue'),
        meta: {title: '税法随便问'}
      },
      {
        path: '/dayiDetails',
        name: 'dayiDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/details/dayiDetails.vue'),
        meta: {title: '税法随便问'}
      },
      {
        path: '/sbwDetails',
        name: 'sbwDetails',
        component: () => import(/* webpackChunkName: "about" */ '../views/details/sbwDetails.vue'),
        meta: {title: '税法随便问'}
      },
    ],
  },
  {
    path: '/webview',
    name: 'WebView',
    component: () => import(/* webpackChunkName: "about" */ '../views/webview/webview.vue'),
    meta: {title: '税法随便问'}
    
  },
  {
    path: '/collection',
    name: 'Collection',
    component: () => import(/* webpackChunkName: "about" */ '../views/collection/collection.vue'),
    meta: {title: '税法随便问'}
  },
  


]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
